// extracted by mini-css-extract-plugin
module.exports = {"list":"IconUl_list__qu0zd","iconList":"IconUl_iconList__yzxg9"};